export var MetricType;
(function (MetricType) {
    MetricType["AUDIENCE"] = "AUDIENCE";
    MetricType["SENT"] = "SENT";
    MetricType["OPEN_RATE"] = "OPEN_RATE";
})(MetricType || (MetricType = {}));
